import { FeatureBox, Body, Header, Text, Title, CSSHeaderPositionLeft, CSSHeaderPositionTop } from './FeatureBox';
FeatureBox.displayName = "FeatureBoxBase";
Body.displayName = "FeatureBox.Body";
Header.displayName = "FeatureBox.Header";
Text.displayName = "FeatureBox.Text";
Title.displayName = "FeatureBox.Title";
export { FeatureBox as default, Body, Header, Text, Title, CSSHeaderPositionLeft, CSSHeaderPositionTop };